import { Form, FormProps } from 'antd'
import React, { memo, ReactNode, useEffect } from 'react'
import { useLogic } from '../hooks/useLogic'

type Props = {
  children: ReactNode
  values: any
  onSubmit?: (values: any) => void
} & ReturnType<typeof useLogic>

const Internal: React.FC<Props> = ({ children, values, save, onSubmit }) => {
  const [form] = Form.useForm()

  const handleChange: FormProps['onValuesChange'] = async (
    _: any,
    _onboarding: any,
  ) => {
    const onboarding = form.getFieldsValue(true)
    save({ ...values, ...onboarding })
  }

  useEffect(() => {
    return () => {
      const onboarding = form.getFieldsValue(true)
      onSubmit?.(onboarding)
    }
  }, [])

  return (
    <Form
      form={form}
      initialValues={values}
      layout="vertical"
      scrollToFirstError
      onValuesChange={handleChange}
    >
      {children}
    </Form>
  )
}

export const Wrapper = memo(Internal)
